export const shayestegiha = {
    "خود کنترلی": {
        value: {},
        desc: "(كنترل رفتارها، تمایلات، هیجان ها و اندیشه خود و حفظ خونسردی، آرامش و سطح عملكرد موثر خود در مواجهه با شرایط سخت و استرس زا)",
        moalefe: [
            "کنترل احساسات، رفتارها، و هیجانات خود در شرایط‌ مختلف‌",
            "غلبه‌ بر افکار منفی‌ و مزاحم‌",
            "کنترل و مدیریت‌ استرس",
            "حفظ‌ تمرکز و پایداری‌ در مواجهه‌ با چالش‌ها",
        ],
        abzar: ["آزمون/ مصاحبه / بازی گروهی"],
        amoozesh: [
            "مدیریت هیجان و استرس های شغلی",
            "مدیریت بر خود",
            "برنامه ریزی توسعه فردی",
        ],
        ketab: [
            "اخلاق حرفه ای، تالیف فرامرز قراملکی، نشر مجنون، 1383",
            "هوش هیجانی،دانیل گلمن، ترجمه: غلامحسین خانقائی، انتشارات نسل نواندیش،1393",
            "برنامه ریزی توسعه فردی (راهنمای عمل خودتوسعه ای مدیران و کارکنان)خدایار ابیلی، ابراهیم مزاری( ناشر: ابجد،خرداد1395",
        ],
    },
    "اعتماد به نفس": {
        value: {},
        desc: "(باور و اعتقاد به قابلیت ها و توانایی های خود با در نظر گرفتن نقاط قوت و ضعف خویش و بدون حس غرور و تعصب. همچنین احترام به خود و ارزش قائل بودن برای خود)",
        moalefe: [
            "ایمان و اعتقاد به‌ توانمندی‌ها و قابلیت‌های‌ خود",
            "احترام به‌ خود و ارزش قائل‌ شدن برای‌ خود",
            "داشتن‌ استقلال نظر و دیدگاه",
        ],
        abzar: ["آزمون/ مصاحبه / بازی گروهی"],
        amoozesh: [
            "آسیب شناسی عدم اعتماد به نفسی",
            "خودباوری و خود محوری",
            "مدیریت بر خود",
        ],
        ketab: [
            "جادوی اعتماد به نفس، محمود کریم زاده، ناشر: انتشارات سخنوران،1399",
            "در باب اعتماد به نفس آلن دوباتن، محمد کریمی، انتشارات کتاب‌سرای نیک،1398",
            "اعتماد به نفس، باربارا دی آنجلیس، لقمان سرمدی،ناشر: انتشارات سعید نوین،1389",
        ],
    },
    "پیشگامی و ابتكارعمل": {
        value: {},
        desc: "(كارها به صورت فعالانه، به جای آن كه منتظر پیشنهاد یا دستور دیگران بودن. انجام دادن كارها فراتر از آن چه مورد انتظار یا مورد نیاز است و همچنین انجام دادن)",
        moalefe: [
            "مصر بودن و داشتن‌ پشتکار",
            "پیشقدم شدن در انجام کارها",
            "تعیین‌ اهداف چالش‌ انگیز و ریسک‌ پذیری",
            "استقلال در انجام کار",
            "انگیزه پیشرفت‌ و موفقیت‌",
        ],
        abzar: ["آزمون /  مصاحبه /  بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: [
            "تکنیک های بهبود ابتکار فردی",
            "روش های بهبود خلاقیت",
            "طراحی تفکر",
        ],
        ketab: [
            "تفکر خلاق، حل مشکل و تصمیم گیری،تالیف: توماس.ال. ساعتی، مجید عزیزی (مترجم)، رضا نقدی (مترجم)، نشر دانشگاه تهران، 1392",
            "نوآفرینی، آدام گرانت، ترجمه: رضا رایان راد، محمد علی شفیعا،انتشار 1396",
            "تصمیم گیری خلاق: چگونه در مورد عدم قطعیت مثبت باشید. اچ بی گلات،‌ علیرضا نظر آهاری، سرآمد 1385",
        ],
    },
    "یادگیری مداوم": {
        value: {},
        desc: "(نشان دادن تعهد به یادگیری مداوم و رشد خود و تلاش مستمر برای كسب دانش، مهارت و تخصص لازم و مورد نیاز حرفه خود)",
        moalefe: [
            "علاقه‌ و تمایل‌ به‌ یادگیری‌ و توسعه‌ خود",
            "شرکت‌ در فعالیت‌ های‌ آموزشی‌",
            "جستجوی‌ فرصت‌ های‌ یادگیری‌",
            "بکارگیری‌ آموخته‌ های‌ جدید در کار و عمل‌",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: [
            "اصول یادگیری و یاد دهی",
            "شیوه های نوین یادگیری و کسب دانش",
            "تکنیک های یادگیری",
        ],
        ketab: [
            "یادگیری یادگیری،نویسنده: دیبا شریعت،اشر: انتشارات وانیا، 1397",
            "یادگیری معکوس، نویسنده: جان برگمن، ارون سمز، ناشر: موسسه مدارس یادگیرنده مرآت، 1396",
            "یادگیری ژرف،یان گودفلو، یوشوا بنجیو، آرون کورویل، سجاد ملکی (مترجم)، مائده حاجی آقا محسنی، ناشر: وینا، آتی نگر",
        ],
    },
    "سازگاری و انعطاف پذیری": {
        value: {},
        desc: "(وفق دادن سریع خود با موقعیت های متغیر و محیط ها و فرهنگ های گوناگون و با افراد مختلف به صورت كارآمد و در نظر گرفتن رویكردهای جدید برای شرایط جدید)",
        moalefe: [
            "اشتیاق نسبت‌ به‌ ایده های‌ جدید",
            "تحمل‌ ابهام و تغییرات ناگهانی‌",
            "انطباق دادن خود با تغییر و تحولات محیطی‌",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی یا ایفای نقش"],
        amoozesh: [
            "مدیریت تغییر و تطبیق پذیری",
            "روش های سازگاری",
            "مهارت های ارتباطی در شرایط جدید",
        ],
        ketab: [
            "اخلاق حرفه‌ای، سازگاری و انعطاف‌پذیری در سازمان و پیشرفت شغلی، علیرضا عباسی، ناشر: لیما،1400",
            "انعطاف پذیری،نویسنده: ریک هانسون، فارست هانسون، مترجم: ناهید ملکی، ناشر: نشر نوین،1397",
            "قدرت انعطاف پذیری، دیمیان هیوز، سمانه فلاح، ناشر: انتشارات طاهریان،1392",
        ],
    },
    "توجه به جزئیات": {
        value: {},
        desc: "(دقت در انجام یك كار با در نظر گرفتن تمامی حوزه ها و بخش های كوچك و بزرگ درگیر در كار و توجه به جزئیات و ظرایف آن)",
        moalefe: [
            "در نظر گرفتن‌ ظرایف‌ و جزئیات مسائل‌",
            "بازبینی‌ کارها جهت‌ اطمینان از صحت‌ و کامل‌ بودن",
            "پیروی‌ از استانداردها و دستورالعمل‌ ها",
        ],
        abzar: ["مصاحبه / بحث گروهی / بازی گروهی / ارائه شفاهی"],
        amoozesh: [
            "دوره توسعه تمرکز و دقت در کار",
            "تفکر سیستمی",
            "کارگاه تحلیل و دقت در تفسیر",
        ],
        ketab: [
            "تفکر سیستمی،نویسنده:دنلا اچ. مدوز،مترجم:عادل آذرحامد فلاح تفتی، انتشارات:انتشارات دانشگاه امام صادق (ع)، 1392",
            "کتاب تمرکز حواس، کم نایت، مترجم: سید محمدتقی میرقاسمی ناشر: نشر هورمزد،1401",
            "کتاب تعقیب تمرکز و توجه، رضوان میردریکوند، سارا ضمیری ناشر: انتشارات پارسیان البرز،1398",
        ],
    },
    پاسخگویی: {
        value: {},
        desc: "(پذیرفتن مسئولیت در قبال همه ی فعالیت هایی كه بر عهده ی فرد گذاشته می شود و پاسخگو بودن در قبال نتایج و پیامدهای آن و همچنین حس وظیفه شناسی و پیگیری دلسوزانه امور محوله)",
        moalefe: [
            "پذیرش مسئولیت‌ نتایج‌ و عواقب‌ کارها",
            "پایبندی‌ به‌ تعهدات خود",
            "توجه‌ به‌ مهلت‌ و ضرب الاجل‌ کارها",
            "انجام کارها با کمترین‌ نظارت و پیگیری‌",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی / بازی گروهی"],
        amoozesh: ["اخلاق حرفه ای", "اصول پاسخگویی", "شهروند سازمانی"],
        ketab: [
            "مسئولیت پذیری و به پا خواستن برای تغییر،تالیف: دکتر جان ایزو، ترجمه:ناصر فیروزی، نشر رسا،1399",
            "مسئولیت پذیری،عبدالحسین رفعتیان، نشرقطره،1398",
            "رفتار شهروندی سازمانی،مؤلفان: پرویز احمدی، مهدیه منصوری،ناشر: دفتر پژوهشهای فرهنگی،1395",
        ],
    },
    "هوشیاری فناورانه": {
        value: {},
        desc: "(آگاهی از آخرین فناوری روز (سخت افزار، نرم افزار و فناوری های ارتباطی) و فناوری های نوظهور و كاربردهای آن ها و استفاده و بكارگیری از آن ها جهت به روز كردن فرآیندهای كاری متناسب با مقتضیات زمان)",
        moalefe: [
            "علاقمندی‌ به‌ ابزارها و تکنولوژی‌ های‌ جدید",
            "به‌ روز بودن در خصوص ابزارها و فناوری‌ های‌ جدید",
            "به‌ کارگیری‌ از فناوری‌ های‌ روز",
            "عیب‌ یابی‌ و رفع‌ اشکال تجهیزات و فناوری‌ های‌ روز",
        ],
        abzar: ["مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: [
            "دوره مدیریت پروژه های فناورانه",
            "نظریه عمومی سیستم ها",
            "به روز بودن",
        ],
        ketab: [
            "آشنایی با جدیدترین فناوری‌های جهان: نادر نینوایی، ناشر: انتشارات عصر قلم،1398",
            "آینده نزدیک، کوین کلی، شایان تقی نژاد، ناشر: نشر آموخته،1398",
            "فناوری اطلاعات و هوش سازمانی، الهام رنجبران، ناشر: زلال سبز،1401",
        ],
    },
    "هوشیاری مالی و تجاری": {
        value: {},
        desc: "(شناخت و درك مناسب از اصول اساسی مالی، حسابداری، و اقتصادی به منظور قضاوت صحیح هنگام تصمیم گیری و به كارگیری از آن جهت بهبود كارایی و سودآوری بیشتر سازمان)",
        moalefe: [
            "درك اصول و مبانی‌ مالی‌ و اقتصادی‌",
            "داشتن‌ تفکر هزینه‌-فایده",
            "توجه‌ به‌ فرصت‌ها و روندهای‌ جدید",
        ],
        abzar: ["ارائه شفاهی / مصاحبه / بازی گروهی"],
        amoozesh: [
            "تحلیل راهبردی صنعت",
            "مدیریت مالی پیشرفته برای افراد حرفه ایی غیر مالی",
            "كسب و كارهای نوظهور",
        ],
        ketab: [
            "مدیریت روابط با مشتری،‌چارلز ترنر دیوید الكساندر،‌مهران حمزه گودرزی،‌اندیشه آریا 1386",
            "حل مسایل سازمانی با استفاده از فنون مالی (رویكرد كلنیكی)،‌حسین محمد پوراسماعیل غفاری،‌ آریانا 1387",
            "مهارتهای كاربردی بازاریابی و فروش:مهارتهای مدیریت،‌مشتریان كلیدی،‌راجر جونز،‌علی دنیا دیده،‌اندیشه آریا 1393",
        ],
    },
    "نتیجه گرایی": {
        value: {},
        desc: "(تمركز بر دستیابی به نتایج مطلوب فردی و سازمانی و تلاش مستمر برای حركت در مسیر اهداف تعیین شده و دستیابی به نتایج مطلوب و اهداف موردنظر)",
        moalefe: [
            "تعیین‌ اهداف عملکردی‌ و دنبال کردن آن ها",
            "مرتبط‌ ساختن‌ وظایف‌ کاری‌ خود / دیگران با اهداف سازمانی‌",
            "حرکت‌ و تلاش همسو با اهداف و استانداردهای‌ عملکردی‌",
        ],
        abzar: ["مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: [
            "روش های نظارت و كنترل اثربخش",
            "ارزیابی سازمانی با رویکرد کارت امتیازی متوازن",
            "تكنیك های نوین پیش بینی و برنامه ریزی عملیاتی",
        ],
        ketab: [
            "تمركز هدف:روش های ساده و كارامد برای آسان كردن زندگی،‌ برایان تریسی،‌ منیر الدین اعتضادی،‌ راشین 1382",
            "راهنمای برنامه ریزی سازمانی بر اساس رویكرد هوشین كانری،‌پت ببیچ،‌ مهدی حاجی میر عرب،‌تحقیقات صنعتی 1387",
            "اصول و راه كارهای عملی در برقراری انظباط در سازمانها،‌ استورات امت، علی دنیا دیده، اندیشه آریا 1386",
        ],
    },
    "حل مسئله": {
        value: {},
        desc: "(توانایی شناسایی مشكلات و مسائل موجود و استفاده از یك رویكرد منطقی و نظام مند برای رسیدن به یك راه حل كارآمد و موثر جهت مقابله با مشكلات و مسائل شناسایی شده)",
        moalefe: [
            "تشخیص‌ وجود مسئله‌ و شناخت‌ آن",
            "جمع‌ آوری‌ و سازماندهی‌ اطلاعات موردنیاز جهت‌ حل‌ مسئله‌",
            "یافتن‌/ ارائه‌ راه حل‌ های‌ مختلف‌",
            "انتخاب راه حل‌",
            "پیاده سازی‌ راه حل‌",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: ["خلاقیت و حل مساله", "تفکر تحلیلی", "تکنیک های تفکر خلاق"],
        ketab: [
            "تفکر خلاق، حل مشکل و تصمیم گیری،تالیف: توماس.ال. ساعتی، مجید عزیزی (مترجم)، رضا نقدی (مترجم)، نشر دانشگاه تهران، 1392",
            "تصمیم گیری خلاق: چگونه در مورد عدم قطعیت مثبت باشید. اچ بی گلات،‌ علیرضا نظر آهاری، سرآمد 1385",
            "تفکر خلاق، تالیف: دکتر جواد فقیهی پور و دکتر میثم کشاورز، نشر: مرکز آموزش و مشاوره دارالفنون، 1400",
        ],
    },
    "تصمیم گیری": {
        value: {},
        desc: "(توانایی تجزیه و تحلیل مشكلات و مسائل و استفاده از طیف وسیعی از ابزارها برای تصمیم گیری به موقع و آگاهانه به طوری كه واقعیت ها، اهداف، محدودیت ها و ریسك ها در هنگام تصمیم گیری در نظر گرفته شوند)",
        moalefe: [
            "اخذ اطلاعات جهت‌ درك مسئله‌",
            "نگاه نقادانه‌ به‌ اطلاعات موجود",
            "درك ارتباط بین‌ اطلاعات مختلف‌",
            "بررسی‌ چند بعدی‌ راهکارهای‌ موجود",
            "ریسک‌ پذیری‌ و قاطعیت‌ در اخذ تصمیم‌",
        ],
        abzar: ["ارائه شفاهی / مصاحبه / بازی گروهی"],
        amoozesh: [
            "تصمیم گیری اثربخش",
            "تصمیم گیری چند معیاره",
            "خلاقیت و حل مساله",
        ],
        ketab: [
            "مهارت حل مسئله و تصمیم گیری،‌نسرین امامی، حسام نقره چی،‌هنر آبی 1387",
            "تصمیم گیری خلاق: چگونه در مورد عدم قطعیت مثبت باشید. اچ بی گلات،‌ علیرضا نظر آهاری، سرآمد 1385",
            "مدیریت ریسک در سازمانها،مرتضی واسعی (مترجم)، امیر رضا خاکی (مترجم)،دانشگاه آزاد اسلامی،1387",
        ],
    },
    "ارتباطات شفاهی": {
        value: {},
        desc: "(انتقال صحیح اطلاعات و بیان افكار و حقایق به دیگران به روش شفاهی و استفاده موثر از مهارت شنیداری و توجه به نقطه نظرات و ایده های دیگران)",
        moalefe: [
            "تسلط‌ بر کلام (سیالی‌ کلام)",
            "بیان سنجیده و متقاعد کننده",
            "گوش دادن موثر و فعال",
            "زبان بدن و ارتباط غیرکلامی‌",
            "سبک‌ ارتباطی‌ مناسب‌",
        ],
        abzar: ["ارائه شفاهی / مصاحبه / بازی گروهی"],
        amoozesh: [
            "تكنیك های ارتباط موثر",
            "زبان بدن و ارتباطات غیر کلامی",
            "شنود مؤثر",
        ],
        ketab: [
            "ارتباطات کلامی (شفاهی) به انضمام ارتباط غیرکلامی، حمید قیدی، ناشر: سبحان،1393",
            "زبان بدن :راهنمای تعبیر حرکات بدن، آلن پیز،نشرجانان 1393",
            "ارتباط اثربخش: تیم FME ، اکبر مقدر، مریم امینی ناشر: انتشارات تعالی، 1397",
        ],
    },
    "ارتباطات نوشتاری ": {
        value: {},
        desc: "(فهم‌ مطالب‌ و دستورالعمل‌ های‌ مکتوب، انتقال موثر و دقیق‌ افکار به‌ زبان نوشتاری‌)",
        moalefe: [
            "فهم‌ مطالب‌ و دستورالعمل‌ های‌ مکتوب",
            "انتقال موثر و دقیق‌ افکار به‌ زبان نوشتاری‌",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی یا ایفای نقش / تمرین نوشتاری"],
        amoozesh: ["آیین نگارش", "مهارت نویسندگی", "اتوماسیون اداری"],
        ketab: [
            "آیین نگارش اداری،جمشید غلامی نهاد، ناشر :نشر نیایش،1400",
            "ارتباطات نوشتاری، امیدعلی مسعودی، انتشارات پشتیبان،1400",
            "آیین نگارش نوشته‌های اداری- مکاتبات اداری، مهارت‌های نوشتاری، احمد شعاع، ناشر: فرمنش،1388",
        ],
    },
    "كار تیمی": {
        value: {},
        desc: "(توانایی همكاری اثربخش با دیگران برای دستیابی به اهداف مشترك سازمانی، بدون تكیه بر روابط رسمی سازمانی و موقعیت های افراد در چارت های رسمی)",
        moalefe: [
            "پذیرش عضویت‌ و نقش‌ در تیم‌",
            "برقراری‌ روابط‌ موثر با اعضای‌ تیم‌",
            "همکاری‌ با دیگران جهت‌ تحقق‌ اهداف تیم‌",
            "حل‌ تعارضات و اختلافات",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی / بازی گروهی"],
        amoozesh: [
            "کار تیمی و مهارت های تیم سازی",
            "مدیریت مشارکتی",
            "شبکه سازی",
        ],
        ketab: [
            "راز موفقیت كار تیمی:راهنمای عملی برای پویایی هایی گروهی،ریچاردوای چانگ علوی غرقی،‌مدیریت دولتی 1381",
            "تحلیل رفتار متقابل، اریك برن ترجمه اساعیل فصیح، نشر نو، 1389",
            "راهکارهایی برای بالا بردن کیفیت کار گروهی، جان گوردون،‌فیروزه مهرزاد،‌ لیوسا 1392",
        ],
    },
    "تیم و شبكه سازی": {
        value: {},
        desc: "(ایجاد و گسترش روابط گروهی و مشترك و استفاده از روش های مناسب و انعطاف پذیر برای ساختن تیم های رسمی و غیر رسمی كه رسیدن به اهداف تیمی را تسهیل می بخشند)",
        moalefe: [
            "ایجاد روابط‌ مبتنی‌ بر احترام و درك متقابل‌",
            "حفظ‌ روابط‌ و جلب‌ همکاری‌",
            "نفوذ و تاثیرگذاری‌ بر دیگران",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی / بازی گروهی"],
        amoozesh: ["مهارت های تیم سازی", "هدایت و رشد تیمی", "مدیریت بین فردی"],
        ketab: [
            "شبکه‌سازی موفق برای هم ه اریک کرامر، خلیل رضوی، اشرف شجاعی، ناشر: انتشارات کهکشان دانش،1396",
            "کوچینگ تیم و سازمان، مارک ساموئل، سارا ساموئل، محمدرضا ترابیان اصفهانی، ناشر: انتشارات گیوا،1403",
            "راهکارهایی برای بالا بردن کیفیت کار گروهی، جان گوردون،‌فیروزه مهرزاد،‌ لیوسا 1392",
        ],
    },
    همدلی‌: {
        value: {},
        desc: "(توانایی درك اندیشه ها، احساسات و نگرانی های دیگران و فهم تجربه حسی دیگران با قرار دادن خود در جایگاه آن ها و دیدن دنیا از دریچه چشم آن ها)",
        moalefe: [
            "اظهار توجه‌ مثبت‌/ دید مثبت‌ به‌ دیگران",
            "درك احساسات، نیازها و دغدغه‌ های‌ دیگران",
            "جستجوی‌ راه مناسب‌ جهت‌ کمک‌ و راهنمایی‌ دیگران",
        ],
        abzar: ["مصاحبه / بحث گروهی / بازی گروهی"],
        amoozesh: [
            "مهارتهای ارتباطی",
            "بهبود سطح همدلی و همراهی",
            "مدیریت تعارض",
        ],
        ketab: [
            "مردم‌داری در حکومت اسلامی،علی تقوی‌دهکلاتی، نشر نگاه تعالی،1396",
            "همدلی، انتشارات هاروارد بیزینس ری‌ویو، فرخ بافنده، انتشارات:پندار تابان",
            "کتاب راهنمای آموزش عملی مهارت همدلی : سمیه غلامی، حکیمه حرمتی، انتشارات:انتشارات رشد فرهنگ",
        ],
    },
    "مدیریت تعارض": {
        value: {},
        desc: "(مواجهه و برخورد مناسب با دیگران در وضعیت خصومت آمیز و استفاده از شیوه ها و روش های مناسب بین فردی برای كاهش تنش یا تعارض بین دو یا چند نفر)",
        moalefe: [
            "تشخیص‌ منشاء تعارضات",
            "تشویق‌ و کمک‌ به‌ حل‌ و فصل‌ تعارضات مخرب",
            "نهی‌ کردن از رفتارهای‌ غیرسازنده",
            "ترویج‌ روحیه‌ همکاری‌ و احترام و اعتماد متقابل‌",
        ],
        abzar: ["مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: ["مدیریت تعارض", "مدیریت بر خود", "مدیریت تعارض در مذاکره"],
        ketab: [
            "مدیریت تعارض و فنون مذاكره،نویسنده: نعمت مهدوی‌راد، اشر: مركز آموزش مدیریت دولتی،1392",
            "مدیریت تعارض،مؤلفان: کیم کمرون، دیویدآلرد وتن،مترجمان: سیدمهدی الوانی، حسن دانایی‌فرد،ناشر: موسسه تحقیقات و آموزش مدیریت،1380",
            "مدیریت تعارض در سازمان،مولفان: علی یوسفی‌نژاد‌استادکلایه، سودابه وطن‌خواه، فرشید رادفر، منیره نوری،ناشر: سیدمحمود اخوت،1392",
        ],
    },
    "مشتری مداری": {
        value: {},
        desc: "(داشتن درك عمیق و صحیح از نیازها و انتظارات مشتریان و انجام اقدامات مورد نیاز جهت ارائه خدمات با كیفیت جهت جلب رضایت مشتریان)",
        moalefe: [
            "درك نیازهای‌ مشتری‌",
            "ارائه‌ خدمات متناسب‌ با نیازهای‌ مشتری‌",
            "برخورد حرفه‌ ای‌ با مشتری‌",
            "اطلاع رسانی‌ مناسب‌ و به‌موقع‌ به‌ مشتری‌",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: [
            "مدیریت رفتار با مشتری",
            "ارتباط اثربخش",
            "اصول و فنون مذاکره",
        ],
        ketab: [
            "تكنیك های طلایی ایجاد ارتباط،‌شون میستل،‌ علی دنیا دیده،‌اندیشه آریا 1387",
            "راه و رسم گوش دادن: راهنمای عملی برای گوش دادن موثر،دایانا بونت، نفیسه معتکف (مترجم)، حمیده رستمی (ویراستار)، نسل نو اندیش 1386",
            "هوش هیجانی،دانیل گلمن، ترجمه: غلامحسین خانقائی، انتشارات نسل نواندیش،1393",
        ],
    },
    "جامعیت و تنوع گرایی": {
        value: {},
        desc: "(ایجاد یك محیط كار متنوع و فراگیر كه تمامی افراد با نژادها، قومیت ها، جنسیت ها و فرهنگ های متفاوت احساس احترام و ارزشمندی كنند و فرصت پیشرفت داشته باشند)",
        moalefe: [
            "احترام به‌ تفاوت های‌ نژادی‌ و فرهنگی‌",
            "کار کردن با طیف‌ گسترده ای‌ از افراد گوناگون",
            "برخورد با توهین‌ کنندگان به‌ قومیت‌ ها و فرهنگ‌ های‌ مختلف‌",
        ],
        abzar: ["مصاحبه / بحث گروهی / بازی گروهی / ارائه شفاهی"],
        amoozesh: [
            "تنوع و همه پذیری",
            "هوش هیجانی",
            "تقویت جهانبینی با جامعیت طلبی",
        ],
        ketab: [
            "جامعیت‌پذیری: مدیران چگونه از 'تنوع'، 'برابری' و 'همه‌پذیری' برای پیشبرد اهداف سازمان‌ها بهره می‌برند؟،ویکتوریا متینگلی، سرتریس گرایس، آلیسون گلدستاین،علی پیرزاد، طاهره ابراهیمی‌شاد، علی مازندرانی،ناشر، همارا،1402",
            "مدیریت تنوع در سازمان،مارتا فیلد، محمد شفیق زاده، ناشر: شرکت مهندسی نیروی نفت و گاز سپانیر،1396",
            "چگونی کمال گرایی، استفان گایز، نرگس محمدی ناشر: انتشارات شمشاد، 1398",
        ],
    },
    "تفكر خلاق": {
        value: {},
        desc: "(استفاده از اطلاعات، دانش و ایده های خود برای ایجاد راه حل های بكر و بدیع و زیر سوال بردن رویكردهای متداول و كشف جایگزین ها و پاسخ به چالش ها همراه با به كار گیری راهكارهای خلاقانه، شهودی و دیدگاه های جدید)",
        moalefe: [
            "متفاوت اندیشیدن و استقلال نظر",
            "به‌ کار بردن تحلیل‌های‌ منحصر به‌ فرد",
            "ارائه‌ راه حل‌ های‌ بدیع‌ و خلاقانه‌",
            "استقبال از تغییر و ایدههای‌ جدید",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: ["تفکر خلاق", "روش های بهبود خلاقیت", "حل مسئله به روش TRIZ"],
        ketab: [
            "تفکر خلاق، حل مشکل و تصمیم گیری،تالیف: توماس.ال. ساعتی، مجید عزیزی (مترجم)، رضا نقدی (مترجم)، نشر دانشگاه تهران، 1392",
            "تصمیم گیری خلاق: چگونه در مورد عدم قطعیت مثبت باشید. اچ بی گلات،‌ علیرضا نظر آهاری، سرآمد 1385",
            "تفکر خلاق، تالیف: دکتر جواد فقیهی پور و دکتر میثم کشاورز، نشر: مرکز آموزش و مشاوره دارالفنون، 1400",
        ],
    },
    "تفكر استراتژیك": {
        value: {},
        desc: "(توانایی پیش بینی محیط آینده با توجه به فرصت ها و تهدیدها و اتخاذ مجموعه اقدامات مناسب جهت دستیابی به اهداف كلان و چشم انداز سازمان بعد از بررسی اطلاعات، منابع، محدودیت ها و فرصت ها و تهدیدهای موجود)",
        moalefe: [
            "تجسم‌ و تمرکز بر آینده مطلوب",
            "تشخیص‌ و توجه‌ به‌ تحولات و روندهای‌ در حال پیدایش‌",
            "توجه‌ به‌ فرصت‌ ها و تهدیدات",
            "بهره گیری‌ از وقایع‌ گذشته‌ برای‌ پیش‌ بینی‌ آینده",
            "تدوین‌ و اجرای‌ استراتژی‌ ها",
        ],
        abzar: ["مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: [
            "آشنایی با مفاهیم تفکر استراتژیک",
            "تفکر تحلیلی",
            "تفکر سیستمی",
        ],
        ketab: [
            "پنج فرمان برای تفكر استراتژیك، وفا غفاریان، غلامرضا كیانی، فرا) 1384",
            "تفکر تحلیلی، لیندا الدر و ریچارد پاول، شیوا دهقانی، ناشر بهجت، 1395",
            "نگرشی كاربردی بر الگوهای اساسی تفكر سیستمی، فرشید عبدی، ایمان آزمون، چالش، 1390",
        ],
    },
    "تفكر تحلیلی": {
        value: {},
        desc: "(استفاده از یك رویكرد و فرآیند منطقی و نظام مند برای تجزیه و تحلیل مسائل و تشخیص صحیح مفروضات مربوط به هر واقعه یا سناریو، ارزیابی صحیح استدلالات ارائه شده، توانایی قیاس و تفسیر موضوعات)",
        moalefe: [
            "شکستن‌ مسائل‌ پیچیده به‌ اجزای‌ کوچکتر",
            "تشخیص‌ ارتباط بین‌ موضوعات",
            "تفسیر و تحلیل‌ یکپارچه‌ اطلاعات",
            "ارائه‌ راه حل‌ های‌ ممکن‌ و ارزیابی‌ آن ها",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: [
            "آشنایی با مفاهیم تفکر استراتژیک",
            "تفکر تحلیلی",
            "تفکر سیستمی",
        ],
        ketab: [
            "پنج فرمان برای تفكر استراتژیك، وفا غفاریان، غلامرضا كیانی، فرا) 1384",
            "تفکر تحلیلی، لیندا الدر و ریچارد پاول، شیوا دهقانی، ناشر بهجت، 1395",
            "نگرشی كاربردی بر الگوهای اساسی تفكر سیستمی، فرشید عبدی، ایمان آزمون، چالش، 1390",
        ],
    },
    "تفكر نقادانه": {
        value: {},
        desc: "(توانایی تفكر و اندیشه مستدل و منطقی پیرامون مسائل و قضاوت و تصمیم گیری بر مبنای استدلال و شواهد منطقی)",
        moalefe: [
            "ارزیابی‌ میزان صحت‌ و اعتبار اطلاعات",
            "تفسیر دقیق‌ مسائل‌ و داده های‌ عینی‌ و ذهنی‌",
            "استدلال و نتیجه‌گیری‌ منطقی‌",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: ["تفکر انتقادی", "تفکر استراتژیک", "تفکر سیستمی"],
        ketab: [
            "مهارت تفکر انتقادی، هریسون والتون، سید صابر اکبرموسوی، ناشر: انتشارات برگ و باد،1402",
            "تفکر به شیوه جعبه سیاه، متیو سید، سوگل قشقایی، ناشر: نشر میلکان، 1402",
            "تفکر انتقادی و تحلیل هوشمندی، دیوید تی. مور، محمد یوسفی خرایم، امیرسالار ونکی ناشر: انتشارات دانشگاه عالی دفاع ملی تهران،1398",
        ],
    },
    "شم سیاسی": {
        value: {},
        desc: "(آگاهی و شناخت سیاست های داخلی و خارجی كه بر فعالیت سازمان تاثیر می گذارد. درك واقعیت های سیاسی و عمل كردن بر اساس آن ها به گونه ای كه بیشترین اثربخشی و كمترین آثار جانبی منفی برای سازمان ایجاد شود)",
        moalefe: [
            "اعمال نفوذ در سایرین",
            "شناخت‌ جریانات سیاسی",
            "شبکه‌ سازی‌ و گسترش تعاملات",
        ],
        abzar: ["مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: [
            "تصمیم گیری استراتژیک",
            "تفکر تحلیل سیاسی",
            "اصول و فنون مذاکره",
        ],
        ketab: [
            "سواد سیاسی، حمیدرضا بهاری، ناشر: انتشارات امید سخن،1401",
            "گفتمان ایران و جهان آینده، محمدرضا کلان فریبایی، ناشر: انتشارات آوای آرامش،1399",
            "مجموعه مقالات نخستین همایش اندیشه سیاسی اجتماعی امام خمینی (ره)، ناشر: مرکز بین المللی ترجمه و نشر المصطفی،1390",
        ],
    },
    "نظارت و كنترل": {
        value: {},
        desc: "(بررسی پیشرفت برنامه ها و اهداف تعیین شده و میزان دستیابی به آن ها و استخراج مغایرت ها و انحرافات در جهت بهبود وضع موجود)",
        moalefe: [
            "کشف‌ و شناسایی‌ خطاها و مشکلات",
            "بررسی‌ صحت‌ انجام کارها",
            "ارائه‌ بازخورد",
            "کسب‌ اطلاعات، امضاها و تاییدیه‌ ها",
        ],
        abzar: ["مصاحبه / بحث گروهی / بازی گروهی"],
        amoozesh: [
            "افزایش توان کنترل ابعاد کمی و کیفی پیشرفت برنامه ها",
            "پیش بینی عملکرد",
            "بهبود قابلیت بازخورد دهی به کارکنان در جهت اصلاح عملکرد آنها",
        ],
        ketab: [
            "کنترل مدرن، چن‌چی تسونگ، حسن شادکام‌انور، ترجمه:محسن فراهانی، انتشارات گسترش علوم پایه، 1394",
            "نظارت و کنترل از دیدگاه اسلام، حسین معصومی، انتشارات سروش، 1388",
            "اصول کنترل و نظارت در سازمان‌ها، علیرضا اکبری‌سماکوش، ابراهیم سمیع‌پورگیری، ناشر :فرانما،1398",
        ],
    },
    "برنامه ریزی و سازماندهی": {
        value: {},
        desc: "(برنامه ریزی، اولویت بندی و تعیین اهداف و برنامه های عملیاتی از منابع و زمان و به انجام رساندن وظایف كاری تعیین شده)",
        moalefe: [
            "برنامه‌ ریزی‌ و زمان بندی",
            "اولویت‌ بندی‌ کارها",
            "برآورد تجهیزات و منابع‌ مورد نیاز",
            "تخصیص‌ زمان و منابع‌",
        ],
        abzar: ["مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: [
            "اصول سازماندهی و اصلاح فرایندها",
            "تکنیک های نوین مدیریت زمان",
            "تكنیك های نوین پیش بینی و برنامه ریزی عملیاتی",
        ],
        ketab: [
            "مدیریت زمان اثر برایان تریسی، ترجمه یلدا بلارک،نشر کتابسرای بیان",
            "راهنمای برنامه ریزی سازمانی بر اساس رویكرد هوشین كانری،‌پت ببیچ،‌ مهدی حاجی میر عرب،‌تحقیقات صنعتی 1387",
            "برنامه ریزی منابع سازمانی، وینود کومارگارگ - ان . کی . ونکیتا کریشنان ترجمه عادل آذر - محمد جعفر نظری، نشر مهربان،1393",
        ],
    },
    "قدرت مذاكره و متقاعدسازی": {
        value: {},
        desc: "(توانایی اثرگذاری بر افكار، احساسات و نگرش دیگران و انجام مذاكره موفق و كسب توافق و دستیابی به این تضمین كه توافق حاصل از مذاكره اهداف مورد نظر سازمان را تامین می كند)",
        moalefe: [
            "متقاعدسازی‌ و جلب‌ نظر دیگران",
            "اعتمادسازی‌",
            "حل‌ تعارضات",
            "ایجاد راه حل‌ برد-برد",
        ],
        abzar: ["مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: [
            "مهارتهای شنود موثر",
            "زبان بدن و ارتباطات غیر کلامی",
            "اصول و فنون مذاکره",
        ],
        ketab: [
            "اصول و فنون مذاکره، راجر فیشر و ویلیام یوری ترجمه دکتر مسعود حیدری، نشر سازمان مدیریت صنعتی، 1391",
            "تكنیك های طلایی ایجاد ارتباط،‌شون میستل،‌ علی دنیا دیده،‌اندیشه آریا 1387",
            "راه و رسم گوش دادن: راهنمای عملی برای گوش دادن موثر،دایانا بونت، نفیسه معتکف (مترجم)، حمیده رستمی (ویراستار)، نسل نو اندیش 1386",
        ],
    },
    "ایجاد انگیزه و الهام بخشی به دیگران": {
        value: {},
        desc: "(توانایی افزایش تعهد كاری در دیگران با ایجاد انگیزه و روحیه در آن ها تا بتوانند به سازمان در پیشبرد اهدافش كمك كنند)",
        moalefe: [
            "ایجاد اشتیاق",
            "تشکر و قدردانی‌ از زحمات سایرین",
            "پاداش دهی‌ متناسب‌ با عملکرد",
            "الگو شدن برای‌ سایرین",
        ],
        abzar: ["مصاحبه / بحث گروهی /بازی مدیریتی"],
        amoozesh: [
            "اصول سرپرستی",
            "آشنایی با مربی گری و منتورینگ",
            "هنر رهبری با روش ال پی آی",
        ],
        ketab: [
            "پرورش استعداد رهبری: رویکردی عملی برای تداوم شریان رهبری در سازمان، دیوید برک، مایکل ای. کاسلر،دیوید برک، مایکل ای. کاسلر، ناشر: سازمان انتشارات جهاد دانشگاهی ",
            "توانمندسازی کارکنان و واگذاری کار و تفویض اختیار سیدحسین ابطحی، سعید عابسی ناشر: فوژان، موسسه فرهنگی هنری رایزنان فرهنگ تاریخ نشر: خرداد، 1395 ",
            "مربی گری، تالیف: جان ایتون، روی جانسون، نشر سارگل،1385",
        ],
    },
    رهبری: {
        value: {},
        desc: "(توانایی اعمال نفوذ و ایجاد انگیزه و روحیه در افراد و تشویق آن ها به انجام وظایف و تعهدات شغلی شان تا بتوانند به سازمان در پیشبرد اهدافش كمك كنند)",
        moalefe: [
            "ایجاد مقبولیت",
            "پیشگامی‌ در رهبری‌ و مدیریت‌ امور",
            "شبکه‌ سازی‌ و جلب‌ مشارکت‌ افراد",
            "افزایش‌ انگیزه و روحیه‌ تیم",
            "اثرگذاری‌ بر افکار و رفتارهای‌ دیگران",
        ],
        abzar: ["مقدمه شفاهی / مصاحبه / بازی گروهی"],
        amoozesh: [
            "هنر رهبری با روش ال پی آی",
            "انگیزش کارکنان",
            "توانمندسازی کارکنان",
        ],
        ketab: [
            "پرورش استعداد رهبری: رویکردی عملی برای تداوم شریان رهبری در سازمان، دیوید برک، مایکل ای. کاسلر،دیوید برک، مایکل ای. کاسلر، ناشر: سازمان انتشارات جهاد دانشگاهی ",
            "توانمندسازی کارکنان و واگذاری کار و تفویض اختیار سیدحسین ابطحی، سعید عابسی ناشر: فوژان، موسسه فرهنگی هنری رایزنان فرهنگ تاریخ نشر: خرداد، 1395 ",
            "مدیریت توانمندسازی کارکنان (رویکردها، الگوها، راهبردها، برنامه ها و ارزیابی)، پرویز احمدی، محمد صفری کهره، ناشر: دفتر پژوهشهای فرهنگی - آبان، 1396",
        ],
    },
    "توسعه دیگران": {
        value: {},
        desc: "(برنامه ریزی و حمایت از توسعه مهارت ها و توانایی های افراد به طوری كه بتوانند مسئولیت های شغلی فعلی و آینده خود را موثرتر انجام بدهند)",
        moalefe: [
            "به‌ اشتراك گذاری‌ دانش‌ و مهارت های‌ خود",
            "تبیین‌ وظایف‌ شغلی‌ و راهنمایی‌ و مشاوره به‌ دیگران",
            "توسعه‌ و آموزش حین‌ انجام کار",
            "ترویج‌ و تشویق‌ به‌ یادگیری",
            "ارائه‌ بازخورد مستمر",
        ],
        abzar: ["آزمون / مصاحبه / بحث گروهی یا ایفای نقش / بازی گروهی"],
        amoozesh: [
            "اصول سرپرستی",
            "دوره افزایش عملکرد در زندگی شخصی و محیط‌های کاری",
            "هنر رهبری با روش ال پی آی",
        ],
        ketab: [
            "دوره افزایش عملکرد در زندگی شخصی و محیط‌های کاری",
            "کتاب مدیریت یادگیری و توسعه کارکنان، کورش فتحی واجارگاه-/ فیروز نوری، ناشر : علم استادان، 1400",
            "توانمندسازی کارکنان و واگذاری کار و تفویض اختیار سیدحسین ابطحی، سعید عابسی ناشر: فوژان، موسسه فرهنگی هنری رایزنان فرهنگ تاریخ نشر: خرداد، 1395 ",
            "مربی گری، تالیف: جان ایتون، روی جانسون، نشر سارگل،1385",
        ],
    },
    "پایش و مدیریت عملكرد": {
        value: {},
        desc: "(كنترل و نظارت بر عملكرد افراد و واحدهای سازمانی با در نظر گرفتن راهبردهای سازمانی و از طریق تعیین شاخص ها و معیارهای عملكردی و اندازه گیری آن ها برای اطمینان از دستیابی به اهداف سازمانی)",
        moalefe: [
            "اندازه گیری‌ پیشرفت‌ کار",
            "ارائه‌ بازخورد و درخواست‌ بازخورد از دیگران",
            "تعیین‌ معیارهای‌ عملکردی‌",
        ],
        abzar: ["مصاحبه /  بحث گروهی / ارائه شفاهی"],
        amoozesh: [
            "منتورینگ",
            "مدیریت و ارزیابی عملکرد",
            "روش های تقویت و روحیه عملکرد",
        ],
        ketab: [
            "مدیریت عملکرد (فرد، تیم و سازمان)،  مایکل آرمسترانگ، بهروز قلیچ لی (مترجم)، نشر صفار، 1398",
            "برنامه‌ریزی استراتژیک و مدیریت عملکرد ORISE، محسن لاسمی، ناشر: انتشارات نظری، 1394",
            "مایکل آرمسترانگ، سعید صفری، ناشر : سازمان جهاد دانشگاهی تهران،،1385",
        ],
    },
};
